<template>
  <swiper
    :modules="modules"
    :slides-per-view="'auto'"
    :space-between="0"
    :loop="true"
    :centered-slides="true"
    navigation
    :speed="600"
    :autoplay="{ delay:4000, disableOnInteraction: false }"
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide class="m" v-for="(item, index) in list" :key="index">
      <figure>
        <a v-if="item.link" :href="item.link">
          <img :src="item.pic" alt="photo" />
        </a>
        <img v-else :src="item.pic" alt="photo" />
      </figure>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>

<script>
import { ref, onMounted } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  setup() {
    const swiperRef = ref(null)

    const onSwiper = (swiper) => {
      swiperRef.value = swiper
    }

    const onSlideChange = () => {
      // 任意の処理を書くならここ
    }

    onMounted(() => {
      if (swiperRef.value) {
        // Swiper 初期化完了後にやりたい処理があればここに書く
        // 例: swiperRef.value.slideTo(0)
      }
    })

    return {
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      onSwiper,
      onSlideChange
    }
  }
}
</script>
